import { Warehouse } from "@mui/icons-material";
import { Card, CardContent, Chip, Grid, LinearProgress, Link, Tooltip } from "@mui/material/";
import { cloneDeep } from "lodash";
import { memo, useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Api from "../../Api";
import { Feature, PermissionContext } from "../../contexts/PermissionContext";
import { IStorageRequest } from "../../interfaces";
import { EmptyContent } from "./EmptyContent";
import './index.scss';
import { WidgetHeader } from "./WidgetHeader";

export const StorageRequestWidget = memo(() => {

    const permissionContext = useContext(PermissionContext);
    const permitted = () => {
        return permissionContext.isPermitted(Feature.StorageRequest);
    }

    const hasRequests = () => {

        if (!permitted()) return false;

        if (storageRequests)
            return storageRequests.length > 0
        return false;
    }

    const [storageRequests, setStorageRequests] = useState<IStorageRequest[] | null>(null);
    const [dataLoading, setDataLoading] = useState(true);
    const [pending, setPending] = useState(false);

    useEffect(() => {
        if (dataLoading && !pending) {
            setPending(true);
            Api.StorageRequests.getByStatus("open").then(x => {

                let list = cloneDeep(x as IStorageRequest[]).reverse();

                setStorageRequests(list);
                setDataLoading(false);
            });
        }
    })



    return (
        <Card elevation={3} className="dashboard-widget dashboard-widget-box">
            <WidgetHeader><Warehouse sx={{ mr: 1 }} /> Storage Requests</WidgetHeader>
            <CardContent sx={{ height: "80%", overflowY: "auto", scrollbarWidth: "thin" }}>

                {dataLoading ? <LinearProgress /> :

                    hasRequests() ?
                        <ul className="widget-list">
                            {storageRequests && storageRequests.map((s, i) => {



                                return <li key={i}>
                                    <Tooltip title={`${s.reference ?? "No Reference"} (${s.dateCreated && new Date(s.dateCreated).toLocaleDateString("en-GB")})`}>
                                        <Link
                                            component={RouterLink}
                                            to={"/storagerequest/update/" + s.storageRequestId}>
                                            <Grid container justifyContent="space-between">
                                                <span>{s.reference ?? "No Reference"}</span>
                                                <Chip
                                                    label={s.statusName}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Grid>

                                        </Link>
                                    </Tooltip>
                                </li>
                            })



                            }
                        </ul>
                        :

                        <EmptyContent
                            contentType={"storage requests" + (permitted() ? "" : " (You do not have permission to view storage requests)")}
                            icon={<Warehouse fontSize="inherit" />}
                        />
                }

            </CardContent>
        </Card >
    );

});
